import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ConfigService {
  private config: any;

  constructor(private http: HttpClient) { }

  loadConfig(): Promise<any> {
    return this.http.get<{ data: string }>('/api/auth/GetConfig')
      .toPromise()
      .then(response =>{return response.data})
      .catch(error => {
        console.error('Error fetching configuration:', error);
        return '';
      });
  }
}
